// utils/cart.js
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL; // adjust if needed

// Ensure a cart exists, returns cartId
export async function getOrCreateCart() {
  let cartId = localStorage.getItem("cartId");
  let user = JSON.parse(localStorage.getItem("user"));
  
  if (!cartId) {
    const { data } = await axios.post(`${API_URL}/cart/cart`, {userId: user ? user.id : null});
    cartId = data.cartId;
    localStorage.setItem("cartId", cartId);
  }

  return cartId;
}

// Universal Add to Cart function
export async function addToCart(productId, quantity = 1, variantId = null) {
  try {
    const cartId = await getOrCreateCart();
    const { data } = await axios.post(`${API_URL}/cart/cart/${cartId}/items`, {
      productId,
      quantity,
      variantId // <-- pass variantId to backend
    });

    console.log("Add to Cart successful:", data);
    
    return data; // updated cart
  } catch (err) {
    console.error("Add to Cart failed:", err);
    throw err;
  }
}
